import React from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
import * as yup from 'yup';

import withRouter from '../libs/withRouter.jsx';
import withAuth from "../libs/withAuth.jsx";

import Monday from "../auth/useMonday.jsx";

import Loader from "../libs/loader.jsx";

import { Button, Heading, TextField, Accordion, Checkbox, MenuButton, Menu, RadioButton, Icon, Tooltip, Search } from "monday-ui-react-core";

import { AccordionItem } from "monday-ui-react-core";
import { MenuItem } from "monday-ui-react-core";

import { Edit, Add, MoveArrowLeft, Settings, Alert, ExternalPage, Check, Info } from "monday-ui-react-core/dist/allIcons";

import mondaySdk from "monday-sdk-js";
const monday = mondaySdk();
monday.setApiVersion(config.monday_api.version);

import Filter from "./filter/filter.jsx";
import Share from "./share/share.jsx";

class DatasetEdit extends React.Component
{
    constructor(props)
    {
        super(props);
        this.params = this.props.router.params;
        
        this.user = this.props.auth.user;
        this.auth = this.props.auth;
        
        this.id = false;
        if( (`id` in this.params) && this.params.id!=0 )
        {
            this.id = this.params.id;
        }
        
        this.state = {
            
            'groups': {
                'items': 'Items',
                'subitems-items': 'Subitems',
                'activity-logs': 'Activity logs',
                'users': 'Users',
                'teams': 'Teams',
                'boards': 'Boards',
                'folders': 'Folders',
                'groups': 'Groups',
                'workspaces': 'Workspaces',
                'tags': 'Tags',
                'updates': 'Updates'
            },
            
            'fields': {
                'items': [],
                'subitems-items': [],
                'activity-logs': [],
                'users': [],
                'teams': [],
                'boards': [],
                'folders': [],
                'groups': [],
                'workspaces': [],
                'tags': [],
                'updates': [],
                'tracket': [],
            },
            'dataset': {
                'id': this.id,
                'name': '',
                'description': '',
                'fields': {
                    'items': [],
                },
                'filter': false,
                'filters': {},
                'shares': {},
                'user': {},
            },
            'checkboxes':{
            },
            'category': {
                'items': {
                    'checked': false,
                    'indeterminate': true,
                },
                'subitems-items': {
                    'checked': false,
                    'indeterminate': false,
                },
                'activity-logs': {
                    'checked': false,
                    'indeterminate': false,
                },
                'users': {
                    'checked': false,
                    'indeterminate': false,
                },
                'teams': {
                    'checked': false,
                    'indeterminate': false,
                },
                'boards': {
                    'checked': false,
                    'indeterminate': false,
                },
                'folders': {
                    'checked': false,
                    'indeterminate': false,
                },
                'groups': {
                    'checked': false,
                    'indeterminate': false,
                },
                'workspaces': {
                    'checked': false,
                    'indeterminate': false,
                },
                'tags': {
                    'checked': false,
                    'indeterminate': false,
                },
                'updates': {
                    'checked': false,
                    'indeterminate': false,
                },
                'tracket': {
                    'checked': false,
                    'indeterminate': false,
                },
            },
            'errors': {
                
            },
            'view':
            {
                'types': false,
                'ids': false,
            },
            
            user: this.user,
            auth: this.auth,
        };
        
        this.headadd = React.createRef();
        this.headedit = React.createRef();
        
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.fieldChange = this.fieldChange.bind(this);
        this.viewChange = this.viewChange.bind(this);
        this.filtersUpdate = this.filtersUpdate.bind(this);
        this.shareUpdate = this.shareUpdate.bind(this);
        this.itemsFilterCount = this.itemsFilterCount.bind(this);
        
        this.loader = React.createRef();
        this.synStateTimer = false;
    }
    
    async promisedSetState(newState)
    { 
        var state = this.state;
        for(let key of Object.keys(newState))
        {
            state[key] = newState[key];
        }
        
        this.state = state;
        
        var this_component = this;
        if(this.synStateTimer==false)
        {
            this.synStateTimer = setTimeout( () => { 
                this_component.setState( {...this_component.state} );
                this_component.synStateTimer = false; 
            }, 100);
        }
        
        return true;
    }
    
    
    handleSubmit(e)
    {
        e.preventDefault();
    }
    
    async handleInputChange(key,value)
    {
        var dataset = this.state.dataset;
        
        dataset[key]= value;
        
        await this.promisedSetState({'dataset': dataset});
    }
    
    
    async validate(data)
    {
        let schema = yup.object().shape({
            name: yup.string().required().label('Name'),
            description: yup.string().label('Description').nullable().default(''),
        });
        
        try
        {
            let valid = await schema.validate(data, { abortEarly: false });
            
            let errors = this.state.errors;
            for(var i in data)
            {
                errors[i] = {};
            }
            await this.promisedSetState({'errors': errors});
            
            return true;
        }
        catch(e)
        {
            let errors = this.state.errors;
        
            for(var i in e.inner)
            {
                let error = e.inner[i];
                errors[error.path] = { status: 'error', text: error.message };
            }
            
            await this.promisedSetState({'errors': errors});
        }
        return false;
    }
    

    
    async categoryChange(e, type)
    {
        const { target, nativeEvent } = e;
        
        let expanded = $('#fields_'+type+' button').attr('aria-expanded');
        
        if(target.checked)
        {
            //check all
            if( !this.state.category[type].checked && !this.state.category[type].indeterminate)
            {
                let dataset = this.state.dataset;
                if( !(type in dataset.fields) ) dataset.fields[type] = [];
            
                await this.promisedSetState({'dataset': {...dataset} });
                await this.markCategory(type);
            }
            else
            {
                await this.fieldCheckAll(type);
            }
        }
        else
        {
            //uncheck all
            if( this.state.category[type].checked && this.state.category[type].indeterminate)
            {
                await this.fieldCheckAll(type);
            }
            else
            {
                await this.fieldUnCheckAll(type);
            }
        }
        
        //expand accardion block
        if( ( expanded == 'false') && (this.state.category[type].checked == true) )
        {
            $(target).closest('button').trigger('click');
        }
    }
    
    
    async viewChange(index)
    {
        let view = this.state.view;
                
        view[index] = Boolean(view[index] ^ true);
        
        await this.promisedSetState({'view': view});
    }
    
    
    async markCategory(type)
    {
        let category = this.state.category;
        let changes = false;
        
        if( !(type in category) )
        {
            category[type] = {
                'checked': false,
                'indeterminate': false,
            };
            changes = true;
        }
        
        if( (type in this.state.dataset.fields) && category[type].checked != true )
        {
             category[type].checked = true;
             changes = true;
        }
        
        if( !(type in this.state.dataset.fields) && category[type].checked != false )
        {
             category[type].checked = false;
             changes = true;
        }
        
        //check if any item with 'false' exists in array
        let checkboxes = this.state.checkboxes[type].findIndex(function(element) { return element === false; } );
        
        if(category[type].checked && checkboxes != -1 && category[type].indeterminate == false )
        {
            category[type].indeterminate = true;
            changes = true;
        }
        
        if(category[type].checked && checkboxes == -1 && category[type].indeterminate == true )
        {
            category[type].indeterminate = false;
            changes = true;
        }
        
        if(!category[type].checked && category[type].indeterminate == true )
        {
            category[type].indeterminate = false;
            changes = true;
        }
       
        
        if(changes)
        {
            await this.promisedSetState({'category': {...category} });
        }
        
        return true;
    }
    
    async markCheckbox(type, item, value )
    {

        let checkboxes = this.state.checkboxes;
        
        let index = this.state.fields[type].findIndex(function(element) { return (element.name == item.name && element.type == item.type && element.id == item.id); } );
        if(index >= 0)
        {
            if(('hide' in item) && (item.hide===true)) value = null;
        
            checkboxes[type][index] = value;
            await this.promisedSetState({'checkboxes': {...checkboxes} });
        }
        
        await this.markCategory(type);
        
        return true;
    }
    
    async fieldCheckAll(type)
    {
        var startDate = new Date();

        var this_component = this;
        
        
        for await (const element of this.state.fields[type])
        {
            if(element.type != 'default_fields' && !( ('hide' in element) && (element.hide===true)) ) await this_component.fieldAdd(type, element);
        }
         
        var endDate   = new Date();
        var seconds = (endDate.getTime() - startDate.getTime());
    }
    
    async fieldUnCheckAll(type)
    {
        var this_component = this;
        
        for await (const element of this.state.fields[type])
        {
            await this_component.fieldRemove(type, element);
        }
        
        let dataset = this.state.dataset;
        delete dataset.fields[type];
        await this.promisedSetState({'dataset': {...dataset} });
        
        await this.markCategory(type);
    }
    
    /*use for remove fields in item record which don't important for backend*/
    removeUnusedfieldsFromItem(item)
    {
        var fields = ['id','type','name'];
        var keys = Object.keys(item);
        
        let cloned = {...item};
        
        keys.forEach((key) => {
            if(!fields.includes(key)) delete cloned[key];
        });
        
        return cloned;
    }
    
    async fieldAdd(type, item)
    {
        let dataset = this.state.dataset;
        let filterd = [];
        
        if( (type in dataset.fields) )
            filterd = dataset.fields[type].filter( function(element) { return (element.name == item.name && element.type == item.type && element.id == item.id); } );
        
        if(filterd.length == 0)
        {
            if( !(type in dataset.fields) ) dataset.fields[type] = [];
            
            item = this.removeUnusedfieldsFromItem(item);
            
            dataset.fields[type].push(item);
            await this.promisedSetState({'dataset': {...dataset} });
        }
        if(item.type !='default_fields')
        {
            await this.markCheckbox(type, item, true );
        }
        return true;
    }
    
    async fieldRemove(type, item)
    {
        let dataset = this.state.dataset;
        let filterd = [];
        
        if( (type in dataset.fields) )
            filterd = dataset.fields[type].filter( function(element) { return !(element.name == item.name && element.type == item.type && element.id == item.id); } );
        
        
        let old_length = 0;
        if(type in dataset.fields) old_length = dataset.fields[type].length;
        
        if(filterd.length != old_length)
        {
            dataset.fields[type] = filterd;
            await this.promisedSetState({'dataset': {...dataset} });
        }
        if(item.type !='default_fields')
        {
            await this.markCheckbox(type, item, false );
        }
    }
    
    async fieldChange(e, type, item)
    {
        const { target, nativeEvent } = e;
         
        let dataset = this.state.dataset;
        if(target.checked)
        {
            await this.fieldAdd(type, item);
        }
        else
        {
            await this.fieldRemove(type, item);
        }
    }
    
    
    
    
    
    
    async initFields()
    {
        var this_component = this;

        let items =  await Monday.getItemsFields(this_component.loader);
        let subitemsItems =  await Monday.getSubItemsFields(this_component.loader);
        let activityLogs =  await Monday.getActivityLogsFields();
        let users =  await Monday.getUsersFields();
        let teams =  await Monday.getTeamsFields();
        let boards =  await Monday.getBoardsFields();
        let folders =  await Monday.getFoldersFields();
        let groups =  await Monday.getGroupsFields();
        let workspaces =  await Monday.getWorkspacesFields();
        let tags =  await Monday.getTagsFields();
        let updates =  await Monday.getUpdatesFields();
        let tracket =  await Monday.getTracketFields();
        
        let fields = this_component.state.fields;
        
        fields['items'] = items;
        fields['subitems-items'] = subitemsItems;
        fields['activity-logs'] = activityLogs;
        fields['users'] = users;
        fields['teams'] = teams;
        fields['boards'] = boards;
        fields['folders'] = folders;
        fields['groups'] = groups;
        fields['workspaces'] = workspaces;
        fields['tags'] = tags;
        fields['updates'] = updates;
        fields['tracket'] = tracket;
        
        await this.promisedSetState({'fields': {...fields} });
    }
    
    async initCheckbox(type)
    {
        var this_component = this;
        let checkboxes = this.state.checkboxes;
        
        if( !(type in checkboxes) )
        {
            checkboxes[type] = [];
            await this_component.promisedSetState({'checkboxes': {...checkboxes} });
        }
        
        //mark default fields if category selected
        if(type in this_component.state.dataset.fields)
        {
            await this_component.markCategory(type);
        }
        //end
        
        for await (const element of this_component.state.fields[type])
        {
            if(element.type != 'default_fields')
            {
                let value = false;
                let filterd = [];

                if( (type in this_component.state.dataset.fields) && (typeof this_component.state.dataset.fields[type] != 'undefined') )
                {
                    filterd = this_component.state.dataset.fields[type].filter( function(item) { return (element.name == item.name && element.type == item.type && element.id == item.id); } );
                    if(filterd.length>0) value = true;
                }
                await this_component.markCheckbox(type, element, value);
            }
        }
    }
    
    itemLabelNameView(item)
    {
        var highlightclass="";
        
        if(item.highlight==true) highlightclass="items_filter_highlight";
        
        return (<span className={highlightclass}>{item.name}</span>);
    }
    
    
    itemLabelView(item, notices)
    {
        var div = (<div>
                <span>{this.itemLabelNameView(item)}{notices}</span>
                { (this.state.view.types === true) && <div className="text-secondary">Type: {item.type}</div>}
                { (this.state.view.ids === true) && <div className="text-secondary">ID: {item.id}</div>}
        </div>);
        
        return div;
    }
    
    async filterChange(filter)
    {
        var this_component = this;
        let dataset = this_component.state.dataset;
        
        dataset.filter = filter;
        await this_component.promisedSetState({'dataset': {...dataset} });
        
        await this_component.applyFilterToItemsFields();
    }
    
    async shareUpdate(shares)
    {
        var this_component = this;
        var dataset = this_component.state.dataset;
        
        dataset.shares = {...shares};
        await this_component.promisedSetState({'dataset': {...dataset} });
    }
    
    async filtersUpdate(filters)
    {
        var this_component = this;
        var dataset = this_component.state.dataset;
        
        dataset.filters = filters;
        await this_component.promisedSetState({'dataset': {...dataset} });
        
        await this_component.applyFilterToItemsFields();
    }


    async applyFilterToItemsFields()
    {
        var this_component = this;
        var fields = {...this_component.state.fields};
        var filters = {...this_component.state.dataset.filters};
        
        for await (const type of ['items','subitems-items'])
        {
            fields[type] = fields[type].map( function(item) {
                if( ('hide' in item) ) delete item.hide;
                return item;
            });
            
            
            var checkboxes = {...this.state.checkboxes};
            checkboxes[type] = checkboxes[type].map( function(item) {
                if( item === null ) item=false;
                return item;
            });
            await this_component.promisedSetState({'checkboxes': checkboxes });
            

            for await ( const key of Object.keys(fields[type]) )
            {
                var item = fields[type][key];

                if( 
                    ('boards' in item) 
                    && (
                        (
                            this_component.state.dataset.filter == false
                        )
                        || (
                            !('archive' in filters)
                            ||
                            filters.archive != true
                        )
                    )
                    && !item.boards.map((item) => { if( 'parent_board' in item ) return item.parent_board.state; else return item.state; }).some(state => ['active'].includes(state))
                )
                {
                    item.hide = true;
                }

                if(
                    this_component.state.dataset.filter == true
                    && ('boards' in item) 
                    && ('boards' in filters) 
                    && Array.isArray(filters.boards) 
                    && (filters.boards.length > 0) 
                    && !item.boards.map((item) => { if( 'parent_board' in item ) return item.parent_board.id; else return item.id; }).some(board_id => filters.boards.includes(board_id))
                )
                {
                    item.hide = true;
                }

                if(
                    this_component.state.dataset.filter == true
                    &&
                    ('workspaces' in item) 
                    && ('workspaces' in filters) 
                    && Array.isArray(filters.workspaces) 
                    && (filters.workspaces.length > 0) 
                    && !item.workspaces.map((item) => { return item.id; }).some( workspace_id => filters.workspaces.includes(workspace_id)) 
                )
                {
                    item.hide = true;
                }

                if(item.hide)
                {
                    await this_component.fieldRemove(type, item);
                }

                fields[type][key] = item;
            }
            await this_component.markCategory(type);
        }

        await this.promisedSetState({'fields': {...fields} });
    }
    
    
    async handleItemsFiterChange(value)
    {
        var this_component = this;
        var fields = {...this_component.state.fields};
        
        var flag = false;
        
        for await ( const type of Object.keys(fields) )
        {
            for await ( const key of Object.keys(fields[type]) )
            {
                var item = fields[type][key];
                
                var result= item.name.match(new RegExp(value, "i"));
                
                if(value.length<=1 && item.highlight == true)
                {
                    delete item['highlight'];
                    flag = true;
                    fields[type][key] = item;
                }
                else if(value.length<=1)
                {
                    //skip
                }
                else if(result && !('highlight' in item))
                {
                    item.highlight = true;
                    flag = true;
                    fields[type][key] = item;
                }
                else if(!result && item.highlight == true)
                {
                    delete item['highlight'];
                    flag = true;
                    fields[type][key] = item;
                }
            }
        }
        
        if(flag==true)
        {
            await this_component.promisedSetState({'fields': {...fields} });
        }
    }
    
    itemsFilterCount(type)
    {
        var this_component = this;
        var fields = {...this_component.state.fields};
        var count = 0;
        
        for ( const key of Object.keys(fields[type]) )
        {
            var item = fields[type][key];
            
            if( !('hide' in item) && ('highlight' in item) && item.highlight == true )
            {
                count++;
            }
        }
        
        
        return (count>0)?count:'';
    }
    
    async enableExtensionsOnCreateNew()
    {
        var this_component = this;
        
        let groups = this_component.state.groups;
        
        if(this_component.state.auth.tracketTokenValid === true)
        {
            groups['tracket'] = 'Tracket';
            await this_component.initCheckbox('tracket');
        }
        
        await this_component.promisedSetState({'groups': {...groups} });
    }
    
    async enableExtensionsOnLoad()
    {
        var this_component = this;
        let dataset = this_component.state.dataset;
        let groups = this_component.state.groups;
        
        if( (('fields' in dataset) && ('tracket' in dataset.fields)) || this_component.state.auth.tracketTokenValid === true )
        {
            groups['tracket'] = 'Tracket';
        }
        
        await this_component.promisedSetState({'groups': {...groups} });
    }

    async componentDidMount()
    {
        var this_component = this;
        this_component.loader.current.showLoader();
        
        await this_component.initFields();
        
        for await (const key of Object.keys(this_component.state.groups))
        {
            await this_component.initCheckbox(key);
        }
        
        await this_component.load();
        await this_component.applyFilterToItemsFields();
        
        //convert input to textarea for monday.com component TextField
        $(".converttotextarea input").each(function () {
            var $txtarea = $("<textarea />");
            $txtarea.attr("id", this.id);
            $txtarea.attr("class", "form-control textarea-component__input resize-vertical");
            $txtarea.attr("autocomplete", this.autocomplete);
            $txtarea.attr("placeholder", this.placeholder);
            $txtarea.attr("type", this.type);
            $txtarea.attr("aria-label", this.ariaLabel);
            $txtarea.attr("type", this.type);
            $txtarea.attr("required", this.required);
            $txtarea.attr("data-testid", this.dataTestid);
            $txtarea.val( (this_component.state.dataset.description==null?'':this_component.state.dataset.description) );
            $txtarea.on( "change", function() {
                this_component.handleInputChange('description', $( this ).val() );
            } );

            $(this).replaceWith($txtarea);
        });
        //end convert
        
        this_component.loader.current.hideLoader();
    }
    
    async load()
    {
        var this_component = this;
        
        if( (`id` in this_component.params) && this_component.params.id!=0 )
        {
            var data = {};
            data['id'] = this_component.params.id;

            this_component.loader.current.showLoader();
            
            try
            {
                
                var url = '/api/v1/dataset/get';
                var response = await axios.get(url, { 'params': data} );
                
                if(response.data.error==0)
                {
                    let dataset = response.data.item;

                    if(dataset.description == null) dataset.description = '';

                    if( !(`fields` in dataset) )
                    {
                        dataset.fields = {
                            //'items': [],
                        };
                        dataset.filter = false;
                        dataset.filters = {};
                        dataset.shares = {};
                    }
                    else
                    {
                        //laravel AsArrayObject return empty object as array. we need object there
                        if(Array.isArray(dataset.fields) && dataset.fields.length == 0) dataset.fields = {};
                        dataset.fields = dataset.fields?dataset.fields:{};

                        dataset.filter = dataset.filter?dataset.filter:false;

                        if(Array.isArray(dataset.filters) && dataset.filters.length == 0) dataset.filters = {};
                        dataset.filters = dataset.filters?dataset.filters:{};
                        
                        if(Array.isArray(dataset.shares) && dataset.shares.length == 0) dataset.shares = {};
                        dataset.shares = dataset.shares?dataset.shares:{};
                    }

                    await this_component.promisedSetState({'dataset': {...dataset} });
                    
                    await this_component.enableExtensionsOnLoad();
                    
                    //console.log({...this_component.state.dataset});
                    //console.log({...this_component.state.user});
                    
                    for await (const key of Object.keys(this_component.state.groups))
                    {
                        await this_component.initCheckbox(key);
                    }

                    this_component.loader.current.hideLoader();
                }
            }
            catch(error)
            {
                console.log('DatasetEdit get error', error, error.response);

                if('error_message' in error.response.data)
                {
                    monday.execute("notice", { 
                        message: error.response.data.error_message,
                        type: "error", // or "error" (red), or "info" (blue)
                        timeout: 30000,
                    });
                }

                this_component.loader.current.hideLoader();
            };
        }
        else
        {
            await this_component.enableExtensionsOnCreateNew();
        }
    }
    
    
    async add(e)
    {
        e.preventDefault();
        
        var this_component = this;
        
        if(!await this.validate(this_component.state.dataset)) return false;
        
        var data = new FormData();
        data.append('name', this_component.state.dataset.name );
        data.append('description', this_component.state.dataset.description );
        data.append('fields', JSON.stringify( this_component.state.dataset.fields ) );
        data.append('filter', this_component.state.dataset.filter );
        data.append('filters', JSON.stringify( this_component.state.dataset.filters ) );
        data.append('shares', JSON.stringify( this_component.state.dataset.shares ) );
        
        this_component.loader.current.showLoader();
        
        axios.post('/api/v1/dataset/create', data)
            .then(response => {

                if(response.data.error==0)
                {

                    monday.execute("notice", { 
                        message: 'Connector created successfully',
                        type: "success", // or "error" (red), or "info" (blue)
                        timeout: 10000,
                    });
                    
                    var moveEvent = new CustomEvent('afterCreateDataset', { 
                        detail: { },
                        bubbles: true,
                        composed: true,
                    });
                    ReactDOM.findDOMNode(this_component).dispatchEvent(moveEvent);
                    
                    this_component.props.router.navigate(-1);
                }
                
                this_component.loader.current.hideLoader();
            })
            .catch(error => {
                console.log('DatasetEdit create error', error, error.response);

                if('error_message' in error.response.data)
                {
                    monday.execute("notice", { 
                        message: error.response.data.error_message,
                        type: "error", // or "error" (red), or "info" (blue)
                        timeout: 30000,
                    });
                }
                
                this_component.loader.current.hideLoader();
            });
    }
    
    async edit(e)
    {
        e.preventDefault();

        var this_component = this;

        if( !(`id` in this_component.params) || this_component.params.id==0 ) { console.log('DatasetEdit Undefined value for `id`'); return false; }

        if(!await this.validate(this_component.state.dataset)) return false;

        var data = new FormData();
        data.append('id', this_component.params.id);
        data.append('name', this_component.state.dataset.name );
        data.append('description', this_component.state.dataset.description );
        data.append('fields', JSON.stringify( this_component.state.dataset.fields ) );
        data.append('filter', this_component.state.dataset.filter );
        data.append('filters', JSON.stringify( this_component.state.dataset.filters ) );
        data.append('shares', JSON.stringify( this_component.state.dataset.shares ) );

        this_component.loader.current.showLoader();
        
        var url = '/api/v1/dataset/save';
        if(this_component.state.user.is_admin == true && this_component.state.dataset.user.monday_user_id != this_component.state.user.id)
        {
            url = '/api/v1/dataset/admin_save';
        }
        
        axios.post(url, data)
            .then(response => {

                if(response.data.error==0)
                {
                    monday.execute("notice", { 
                        message: 'Connector saved successfully',
                        type: "success", // or "error" (red), or "info" (blue)
                        timeout: 10000,
                    });

                    var moveEvent = new CustomEvent('afterSaveDataset', { 
                        detail: { },
                        bubbles: true,
                        composed: true,
                    });
                    ReactDOM.findDOMNode(this_component).dispatchEvent(moveEvent);
                    
                    this_component.props.router.navigate(-1);
                }
                
                this_component.loader.current.hideLoader();
            })
            .catch(error => {
                console.log('DatasetEdit save error', error, error.response);

                if('error_message' in error.response.data)
                {
                    monday.execute("notice", { 
                        message: error.response.data.error_message,
                        type: "error", // or "error" (red), or "info" (blue)
                        timeout: 30000,
                    });
                }
                
                this_component.loader.current.hideLoader();
            });
        
        
    }
    
    render()
    {
        var this_component = this;
        
        let head;
        let save;
        
        if( !(`id` in this_component.params) || ((`id` in this_component.params) && this_component.params.id==0) )
        {
            head = (
                <Heading type={Heading.types.h2} style={{'fontWeight':'bold'}} value="Create Data Source" className="pl-0 titleFont textSize16" customColor="var(--primary-text-color)" />
            );
            save =(
                <Button onClick={(e) => this_component.add(e)} type={Button.inputTags.BUTTON} kind={Button.kinds.PRIMARY} size={Button.sizes.SMALL} marginLeft={true} leftIcon={Add}>Save</Button>
            );
        }
        else
        {
            head = (
                <Heading type={Heading.types.h2} style={{'fontWeight':'bold'}} value="Edit Data Source" className="pl-0 titleFont textSize16" customColor="var(--primary-text-color)" />
            );
            save =(
                <Button onClick={(e) => this_component.edit(e)} type={Button.inputTags.BUTTON} kind={Button.kinds.PRIMARY} size={Button.sizes.SMALL} marginLeft={true} leftIcon={Edit}>Save</Button>
            );
        }
        
        return (
            <Loader ref={this_component.loader} hstyle={{'zIndex':1000}}>
                
                {
                    (this_component.state.dataset.user.monday_user_id != this_component.state.user.id && this_component.state.user.is_admin == true)?
                    <div className="alert alert-primary mt-2" role="alert" style={{ 'color':'var(--primary-text-color)', 'backgroundColor': 'var(--primary-selected-color)' }}>
                        <Info style={{ 'verticalAlign': 'top' }} /> Important: If you’re editing a data source containing data from a private board that you don’t have access to, the data related to that board will not be included in the edited version. This applies to all users utilizing this data source. Please ensure you have the necessary permissions before making changes.
                    </div>
                    :
                    null
                }
    
                <form onSubmit={this_component.handleSubmit}>
                    
                    <div className="row">
                        <div className="col-12 col-sm-6">
                            
                            {head}
                            
                            <div className="form-group mb-2">
                                <label className="" style={{'color':'var(--primary-text-color)'}}>Name</label>
                                <TextField placeholder="Name" className="form-control" size={TextField.sizes.MEDIUM} value={this_component.state.dataset.name==null?'':this_component.state.dataset.name} required={true} id="name" onChange={(value) => this_component.handleInputChange('name', value)} validation={ this_component.state.errors.name } />
                            </div>

                            <div className="form-group mb-2">
                                <label className="" style={{'color':'var(--primary-text-color)'}}>Description</label>
                                    <TextField placeholder="Description" wrapperClassName="converttotextarea" className="form-control" size={TextField.sizes.MEDIUM} value={this_component.state.dataset.description==null?'':this_component.state.dataset.description} required={true} id="name" onChange={(value) => this_component.handleInputChange('description', value)} validation={ this_component.state.errors.description } />
                            </div>
                        </div>
                        
                        <div className="col-12 col-sm-6">
                            <Heading type={Heading.types.h2} style={{'fontWeight':'bold'}} value="Share settings" className="pl-0 titleFont textSize16" customColor="var(--primary-text-color)" />
                            
                            <Share shares={ this_component.state.dataset.shares } onUpdate={this_component.shareUpdate} fixed={false} labelsBold="" />
                            
                        </div>
                        
                    </div>
                    
                    <div className="row">
                        <div className="col-12">
                            <Heading type={Heading.types.h2} style={{'fontWeight':'bold'}} value="Filter Items" className="pl-0 titleFont textSize16" customColor="var(--primary-text-color)" />
                            
                            <RadioButton className="widthfitcontent" text="Without Filter" name="filter_radio_button" checked={this_component.state.dataset.filter==false} onSelect={(e) => this_component.filterChange(false)} />
                            <RadioButton className="widthfitcontent" text="With Filter" name="filter_radio_button" checked={this_component.state.dataset.filter==true} onSelect={(e) => this_component.filterChange(true)} />
                            
                            { this_component.state.dataset.filter ? <div className="mt-2"><Filter filters={ this_component.state.dataset.filters } onUpdate={this_component.filtersUpdate} /></div> : null }
                        </div>
                    </div>
                    
                    
                    <div className="row mt-4">
                        <div className="col-3 mb-2">
                            <Search placeholder="Search fields" onChange={(value) => this_component.handleItemsFiterChange(value)} className="form-control" />
                        </div>
                        <div className="col-9 mb-2 my-auto">
                            <div className="float-right">
                                <MenuButton component={Settings} closeDialogOnContentClick={false}>
                                    <Menu id="dataset_edit_view_menu">
                                        <MenuItem title="Show Names" selected={false} icon={Check} />
                                        <MenuItem title="Show Types" className={this.state.view.types?"":"menu_item_hide_icon"} onClick={(e) => this.viewChange('types')} selected={false} icon={Check} />
                                        <MenuItem title="Show IDs" className={this.state.view.ids?"":"menu_item_hide_icon"}  onClick={(e) => this.viewChange('ids')} selected={false} icon={Check} />
                                    </Menu>
                                </MenuButton>
                            </div>
                            <div className="float-right" style={{'height': '100%', 'lineHeight': '32px', 'color': 'var(--primary-text-color)'}}>View Options</div>
                        </div>
                    </div>
                    
                    <Accordion
                        className="monday-storybook-accordion_small-wrapepr"
                        allowMultiple
                        defaultIndex={[]}
                    >
                        {
                            Object.keys(this_component.state.groups).map(function(key, i) {
                                var label = this_component.state.groups[key];
                                return (
                                <AccordionItem id={'fields_' + key} key={'fields_' + key} title={<><div className="items_filter_highlight pl-2 pr-2" style={{'width': 'fit-content', 'display': 'table-cell'}}>{this_component.itemsFilterCount(key)}</div><div style={{'width': '100%','paddingLeft': '10px', 'display': 'table-cell'}}><Checkbox label={label} checked={this_component.state.category[key].checked} indeterminate={this_component.state.category[key].indeterminate} onChange={(e) => this_component.categoryChange(e, key)} /></div></>} >
                                    <div className="d-flex flex-wrap">
                                        {this_component.state.fields[key].map((item, index) => {
                                            
                                            var checkbox=null;
                                            var notices=null;
                                            
                                            if( ('hide' in item) ) return null;
                                            
                                            if('notice' in item)
                                            {
                                                
                                                notices = (
                                                <span key={key +' '+item.name+' '+item.type+' '+item.id+'notice'} style={{'verticalAlign': 'middle'}} className="ml-1">
                                                    { ('table' in item.notice) ? <React.Fragment key="table"><Tooltip content={"Field values will be displayed in " + config.texts.short_name + " as a separate table '"+ item.notice.table +"'"} position={Tooltip.positions.BOTTOM}><Icon icon={ExternalPage} style={{'color':'var(--color-error)'}} /></Tooltip></React.Fragment> : null }
                                                    { ('combined' in item.notice) ? <React.Fragment key="combined"><Tooltip content={"Field values will be displayed in " + config.texts.short_name + " in the table 'Items' & the separate table '"+ item.notice.combined +"'"} position={Tooltip.positions.BOTTOM}><Icon icon={ExternalPage} style={{'color':'var(--color-error)'}} /></Tooltip></React.Fragment> : null }
                                                    { ('export_time' in item.notice) ? <React.Fragment key="export_time"><Tooltip content="Increases export time" position={Tooltip.positions.BOTTOM}><Icon icon={Alert} style={{'color':'var(--color-error)'}} /></Tooltip></React.Fragment> : null }
                                                    { ('2fields' in item.notice) ? <React.Fragment key="2fields"><Tooltip content={"Field values will appear as two distinct columns in " + config.texts.short_name} position={Tooltip.positions.BOTTOM}><Icon icon={Info} style={{'color':'var(--color-error)'}} /></Tooltip></React.Fragment> : null }
                                                </span>
                                                );
                                            }
                                            

                                            if(item.type == 'default_fields')
                                            {
                                                checkbox = <Checkbox className="p-2" label={<span>{this_component.itemLabelNameView(item)}{notices}</span>}  checked={this_component.state.category[key].checked} disabled />;
                                            }
                                            else if(item.type == 'fields')
                                            {
                                                if( (key in this_component.state.checkboxes) && (index in this_component.state.checkboxes[key]) )
                                                {
                                                    checkbox = <Checkbox className="p-2" label={<span>{this_component.itemLabelNameView(item)}{notices}</span>}  checked={this_component.state.checkboxes[key][index]} onChange={(e) => this_component.fieldChange(e, key, item)} />;
                                                }
                                            }
                                            else
                                            {
                                                if( (key in this_component.state.checkboxes) && (index in this_component.state.checkboxes[key]) )
                                                {
                                                    checkbox = <Checkbox className="p-2 align-items-baseline" label={this_component.itemLabelView(item, notices)}  checked={(this_component.state.checkboxes[key][index]===true)?true:false} onChange={(e) => this_component.fieldChange(e, key, item)} />;
                                                }
                                            }
                                            
                                            return (
                                                <div className="col-12 col-sm-6 col-md-4" key={key +' '+item.name+' '+item.type+' '+item.id}>
                                                    {checkbox}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </AccordionItem>
                                );
                            })
                        }
                        
                    </Accordion>
                    
                    <div className="row pb-5">&nbsp;</div>
                    <div className="fixed-bottom" style={{'borderRadius': '8px'}}>
                        <div className="container-fluid" style={{'margin': '8px', 'marginBottom': '0px'}}>
                            <div className="row pl-0 pb-2" style={{'background': 'linear-gradient(rgba( var(--primary-background-color-rgb) , 0) 20%,rgb(var(--primary-background-color-rgb)) 100%)'}}>&nbsp;</div>
                            <div className="row pl-0 pb-3" style={{'backgroundColor': 'var(--primary-background-color)'}}>
                                <div className="col-12">
                                    <Button onClick={(e) => this_component.props.router.navigate(-1)} type={Button.inputTags.BUTTON} kind={Button.kinds.SECONDARY} size={Button.sizes.SMALL} leftIcon={MoveArrowLeft}>Back</Button>
                                    {save}
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </Loader>
        );
    }
}

DatasetEdit.defaultProps = {
};

export default withRouter(withAuth(DatasetEdit));
